"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { AutoSuggest } from '@autoguru/overdrive';
import { memo, startTransition, useCallback, useRef, useState } from 'react';
import { useVehicleLookup } from '../../lib/useVehicleLookup/useVehicleLookup';
import { jsx as _jsx } from "react/jsx-runtime";
export const VehicleSelectInput = /*#__PURE__*/memo(({
  vehicleData,
  waitingMessage,
  className: _className = '',
  onChange,
  value: incomingValue,
  disabled,
  popularOptionsGroupTitle,
  nonePopularOptionsGroupTitle,
  name,
  placeholder,
  isValid,
  isTouched,
  notch,
  reserveHintSpace,
  hintText,
  onFocus,
  onBlur
}) => {
  var _prevValueRef$current;
  const [value, setValue] = useState(incomingValue);
  const prevValueRef = useRef(incomingValue);
  const [inputValue, setInputValue] = useState({
    text: value ? value.name : '',
    payload: null
  });
  const {
    setQuery,
    suggestions,
    optionRenderer
  } = useVehicleLookup({
    waitingMessage,
    query: '',
    vehicles: vehicleData,
    popularOptionsGroupTitle,
    nonePopularOptionsGroupTitle
  });
  if ((incomingValue === null || incomingValue === void 0 ? void 0 : incomingValue.slug) !== ((_prevValueRef$current = prevValueRef.current) === null || _prevValueRef$current === void 0 ? void 0 : _prevValueRef$current.slug)) {
    setValue(incomingValue);
    prevValueRef.current = incomingValue;
    setQuery('');
    setInputValue({
      text: incomingValue ? incomingValue.name : '',
      payload: null
    });
  }
  const reset = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setInputValue({
      text: '',
      payload: null
    });
    setQuery('');
    onChange(null);
  };
  const valueChanged = useCallback(update => {
    if (!update) {
      reset();
    }
    setInputValue(update);
    if (update.payload) {
      startTransition(() => {
        // User has selected a value
        onChange(update.payload);
        setQuery('');
      });
    } else {
      setQuery(update.text);
    }
  }, [onChange]);
  return /*#__PURE__*/_jsx(AutoSuggest, {
    reserveHintSpace: reserveHintSpace,
    className: _className,
    name: name,
    notch: notch,
    autoFocus: false,
    disabled: disabled,
    placeholder: placeholder,
    hintText: hintText,
    isValid: isValid,
    isTouched: isTouched,
    value: inputValue,
    suggestions: suggestions,
    itemRenderer: optionRenderer,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: valueChanged
  });
});